module.exports = __webpack_public_path__ + "static/media/window-close-symbolic.c13cd61c.svg";